import { Component, OnDestroy } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { snFadeInDown } from '@lib/common/animations';

@Component({
  selector: 'fs-welcome-modal',
  templateUrl: './axon-welcome-modal.component.html',
  styleUrls: ['./axon-welcome-modal.component.scss'],
  animations: [snFadeInDown],
})
export class AxonWelcomeModalComponent implements OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  constructor(private readonly _dialogRef: MatDialogRef<AxonWelcomeModalComponent>) {}

  public close(): void {
    this._dialogRef.close();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
